import React, { useState, useEffect, useMemo } from 'react';
import './doctors.scss';
import { message, Tag, Input, Row, Col, Skeleton } from 'antd';
import DoctorAdd from './doctor-add';
import Doctor from '../../../../models/doctor';
import { TableComponent, Card, Button, useTranslation } from 'soxo-bootstrap-core';
import { EditOutlined } from '@ant-design/icons';

const Doctors = (attributes) => {
    const [visible, setVisible] = useState(false);
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [selectedDoctor, setSelectedDoctor] = useState(null);
    const [doctorID, setDoctorID] = useState(false);
    const { Search } = Input;
    const { t } = useTranslation();
    const [query, setQuery] = useState('');

    const doctorModel = new Doctor();

    const fetchDoctors = async () => {
        setLoading(true);
        try {
            const response = await doctorModel.getAllDoctors();
            let doctorsData = [];

            if (Array.isArray(response)) doctorsData = response;
            else if (Array.isArray(response?.data)) doctorsData = response.data;
            else if (Array.isArray(response?.data?.doctors)) doctorsData = response.data.doctors;

            const tableData = (doctorsData || []).map((item, index) => ({
                // key: item.do_code || index,
                code: item.code,
                name: item.name,
                qualification: item.qualification,
                type: item.type,
                active: item.active,
                remarks: item.remarks,
            }));

            setData(tableData);
        } catch (error) {
            message.error('Failed to fetch doctors');
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchDoctors();
    }, []);

    const handleEdit = async (record) => {
        try {
            setLoading(true);
            const res = await doctorModel.getDoctor(record.code);
            const doctorData = res?.data || res?.doctor || res || {};
            setSelectedDoctor(doctorData);
            setDoctorID(true);
            setVisible(true);
        } catch (err) {
            message.error('Failed to load doctor details');
        } finally {
            setLoading(false);
        }
    };

    const handleAddNew = () => {
        setSelectedDoctor(null);
        setDoctorID(false);
        setVisible(true);
    };

    //  Filtering Logic
    const filteredData = useMemo(() => {
        if (!query.trim()) return data;

        const q = query.toLowerCase();

        return data.filter((item) => Object.values(item).some((val) => val && val.toString().toLowerCase().includes(q)));
    }, [query, data]);

    const columns = [
        { title: 'Code', dataIndex: 'code', key: 'code', width: 80 },
        { title: 'Name', dataIndex: 'name', key: 'name', width: 200 },
        { title: 'Qualification', dataIndex: 'qualification', key: 'qualification' },
        {
            title: 'Active',
            dataIndex: 'active',
            key: 'active',
            render: (val) => (val === 'Y' ? <Tag color="green">Active</Tag> : <Tag color="red">Inactive</Tag>),
        },
        { title: 'Reg No', dataIndex: 'regno', key: 'regno' },
        {
            title: 'Remarks',
            dataIndex: 'remarks',
            key: 'remarks',
            ellipsis: true,
        },
        {
            title: 'Actions',
            key: 'actions',
            render: (_, record) => (
                <Button type="link" style={{ borderRadius: '1px' }} onClick={() => handleEdit(record)}>
                    <EditOutlined />
                </Button>
            ),
        },
    ];

    return (
        <>
            <>
                <Card className="doctor-card">
                    {/*  Search + Add Button Same Row With Space Between */}
                    <Row justify="space-between" align="middle" style={{ marginBottom: 16 }}>
                        <Col flex="auto">
                            <Search
                                placeholder={t('Enter Search Value')}
                                allowClear
                                value={query}
                                onChange={(e) => setQuery(e.target.value)}
                                style={{ width: '30%' }}
                            />
                        </Col>

                        <Col style={{ marginLeft: 12 }}>
                            <Button style={{ borderRadius: '1px' }} type="primary" size="small" onClick={handleAddNew}>
                                {t('+ Add New')}
                            </Button>
                        </Col>
                    </Row>
                    {loading ? (
                        <div className="">
                            <Skeleton active />
                        </div>
                    ) : (
                        <TableComponent
                            columns={columns}
                            dataSource={filteredData}
                            loading={loading}
                            pagination={{ pageSize: 10 }}
                            rowKey="key"
                            scroll={{ x: true }}
                        />
                    )}
                </Card>

                <DoctorAdd
                    visible={visible}
                    onCancel={() => setVisible(false)}
                    attributes={attributes}
                    doctorData={selectedDoctor}
                    doctorId={doctorID}
                    onSuccess={fetchDoctors}
                />
            </>
        </>
    );
};

export default Doctors;
